export default __webpack_public_path__ + "static/media/botijao.e7d62ded.svg";